import styled from "@emotion/styled";
import { Button } from "@kaltura/ds-react-components";

export const StyledPlaylistInfo = styled("div")(({ theme }) => ({
    width: 648,
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
    alignSelf: "center",
    [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
        width: "100%",
    },
}));

export const StyledForm = styled("form")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
}));

export const StyledDeleteButton = styled(Button)(({ theme }) => ({
    color: theme.kaltura.palette.danger.main,
    alignSelf: "flex-start",
}));
